import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { dropdownValuesService } from "services";
import { uiActions } from "store";
import { ErrorResponse, SplitProfileItem } from "types";

const useGetResidualsSplitProfileQuery = ({ agentId }: { agentId: string }) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["splitProfileList", agentId],
		() => dropdownValuesService.getSplitProfiles(agentId),
		{
			select: (data): SplitProfileItem[] =>
				data.map(item => ({
					value: item.id,
					name: item.name,
					isHighRisk: item.isHighRisk,
					isAvailable: item.isAvailable,
				})),

			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: error?.title,
					}),
				);
			},
			retry: 0,
			cacheTime: 0,
			enabled: !!agentId,
		},
	);

	return queryResult;
};

export default useGetResidualsSplitProfileQuery;
